import { AnimatePresence, motion } from 'framer-motion';
import { LoaderCircle, Square } from 'lucide-react';
import { SPRING } from 'shared/components/motion/tokens';

interface AutopilotStatusProps {
  label: string | null;
  onStop: () => void;
}

// Barra flutuante enquanto a simulação roda: mostra o passo atual e permite assumir o controle.
export function AutopilotStatus({ label, onStop }: AutopilotStatusProps) {
  return (
    <AnimatePresence>
      {label && (
        <motion.div
          role="status"
          aria-live="polite"
          initial={{ opacity: 0, y: -16, x: '-50%' }}
          animate={{ opacity: 1, y: 0, x: '-50%' }}
          exit={{ opacity: 0, y: -16, x: '-50%' }}
          transition={SPRING}
          className="fixed left-1/2 top-4 z-50 flex items-center gap-3 rounded-full border border-primary/30 bg-ink py-2 pl-4 pr-2 text-sm text-surface shadow-card-hover"
        >
          <LoaderCircle className="h-4 w-4 animate-spin text-primary" aria-hidden="true" />
          <span className="font-medium">Simulação automática</span>
          <span className="hidden max-w-[260px] truncate text-surface/70 sm:inline">· {label}</span>
          <button
            type="button"
            onClick={onStop}
            className="ml-1 flex items-center gap-1.5 rounded-full bg-surface/10 px-3 py-1 text-xs font-semibold hover:bg-surface/20"
          >
            <Square className="h-3 w-3 fill-current" aria-hidden="true" />
            Parar
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
